import { Button, Typography } from '@mui/material';
import React, { ReactNode, SVGProps } from 'react';

interface ButtonLabelProps {
  label: string | ReactNode;
  icon?: SVGProps<SVGElement>;
  onClick: () => void;
}

const ButtonLabel = ({ label, icon, onClick }: ButtonLabelProps) => {
  return (
    <Button
      sx={{ fontSize: '13px', width: '100%', justifyContent: 'flex-start' }}
      color="primary"
      variant="text"
      startIcon={icon || null}
      onClick={onClick}
    >
      <Typography variant="body2">{label}</Typography>
    </Button>
  );
};

export default ButtonLabel;
